// extracted by mini-css-extract-plugin
module.exports = {"email-button":"EmailButton--email-button--3ZoWc","emailButton":"EmailButton--email-button--3ZoWc"};